import React from "react";
import { ForecastTimelineChart } from "@/components/manager/ForecastTimelineChart";
import { usePermissions } from "@/hooks/usePermissions";

export default function NinetyDayInteractiveChartCard() {
  const { hasPermission } = usePermissions();

  if (!hasPermission("view_90day_interactive_chart_card")) {
    return null;
  }

  return <ForecastTimelineChart />;
}
